.sidebar {
    height: 100%;
    width: 380px;
    /* If changing, update the min width in core-entity-page-container.module.css and in header.module.css */
    min-width: 380px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow: auto;
}

.sidebar--sticky {
    position: sticky;
    top: 0;
    height: calc(100vh - 56px);
}

.sidebar--full-height {
    flex-shrink: 0;
    position: sticky;
    top: 0;
    align-self: flex-start;
    height: calc(100% - 16px);
    max-height: 100%;
    padding: 8px 8px 8px 0;
}

/* 1450px matches the breakpoint in use-has-small-sidebar.tsx */
@media (max-width: 1450px) {
    .sidebar {
        width: 340px;
        min-width: 340px;
    }
}
